import React  from 'react';
import {Modal, ModalBody, ModalFooter} from "reactstrap";
import CustomModalHeader from "./CustomModalHeader";
import {useTranslation} from "react-i18next";
import SolidButton from "./SolidButton";
import FlexColumn from "./FlexColumn";
import PropTypes from "prop-types";

function Endorser({label, data}) {
    const {t} = useTranslation()
    return (
        <p><span style={{fontWeight:'bold'}}>{t(label)}</span>: {data}</p>
    )
}

function Endorsee({label, data}) {
    const {t} = useTranslation()
    return (
        data ?
            <p><span style={{fontWeight: 'bold'}}>{t(label)}</span>: {data}</p>
            : null
    )
}

function Endorsement({label, data}) {
    const {t} = useTranslation();
    return (
        <div>
            <p style={{fontWeight: 'bold'}}>{t(label)}</p>
            <p>{data}</p>
        </div>
    )
}

const labelsDictionary = {
    endorse: {
        title: 'confirm endorsement',
        description: 'confirm endorsement description',
        endorsementLabel: 'endorsement label',
        endorserLabel: 'endorser',
        endorseeLabel: 'endorsee',
    },
    cancel: {
        title: 'confirm endorsement cancel',
        description: 'confirm endorsement cancel description',
        endorsementLabel: 'endorsement cancel label',
        endorserLabel: 'endorsement owner',
        endorseeLabel: 'endorsee',
    },
    generic: {
        title: 'confirm endorsement generic',
        description: 'confirm endorsement generic description',
        endorsementLabel: 'endorsement generic label',
        endorserLabel: 'endorser generic',
        endorseeLabel: 'endorsee generic',
    }
}

export default function ConfirmEndorsementModal({isOpen, endorsement, onDone, onCancel}) {

    const {t} = useTranslation()
    const labels = labelsDictionary[endorsement.operation];

    return (
        <Modal isOpen={isOpen}>
            <CustomModalHeader toggle={onCancel}>
                {t(labels.title)}
            </CustomModalHeader>
            <ModalBody>
                <FlexColumn>
                    <p>{t(labels.description)}</p>
                    <Endorser label={labels.endorserLabel} data={endorsement.endorser}></Endorser>
                    <Endorsee
                        label={labels.endorseeLabel}
                        data={endorsement.endorsee}></Endorsee>
                    <Endorsement label={labels.endorsementLabel} data={endorsement.endorsement}></Endorsement>
                </FlexColumn>
            </ModalBody>
            <ModalFooter>
                <SolidButton color="primary" noMargin onClick={onDone}>{t('accept')}</SolidButton>{' '}
                <SolidButton color="secondary" noMargin onClick={onCancel}>{t('cancel')}</SolidButton>
            </ModalFooter>
        </Modal>
    )
}

Endorser.propTypes = {
    data: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
};

Endorsee.propTypes = {
    data: PropTypes.string,
    label: PropTypes.string.isRequired
};

Endorsement.propTypes = {
    data: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
};

ConfirmEndorsementModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    endorsement: PropTypes.shape({
        endorser: PropTypes.string.isRequired,
        endorsee: PropTypes.string,
        endorsement: PropTypes.string.isRequired,
        operation: PropTypes.string.isRequired
    }).isRequired,
    onDone: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

